import { useEffect, useState } from 'react';
import styles from './VideoEdit.module.css';
import TituloAssociado from '../Helper/TituloAssociado';
import Button from '../Forms/Button';
import { useUserContext } from '../../UserContext';
import {
  EDIT_VIDEO,
  GET_CATEGORIAS,
  NOVA_CATEGORIA,
  POST_VIDEO,
} from '../../api';
import Modal from 'react-modal';
import { useNavigate, useParams } from 'react-router-dom';
import { useFileContext, Video } from '../../useFileContext';
import VideoForm from './VideoForm';
import Input from '../Forms/Input';

const EditarVideo = () => {
  const { formData } = useFileContext();
  const navigate = useNavigate();
  const [emailSent, setEmailSent] = useState(false);
  const [openAddCat, setOpenAddCat] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const { setLoading, tokenGer } = useUserContext();
  const { setCategorias } = useFileContext();
  const [initialValues, setInitialValues] = useState<Video>({
    id: undefined,
    url: '',
    titulo: '',
    descricao: '',
    categoria_id: undefined,
    convenio_id: undefined,
  });
  const { video } = useFileContext();
  const [novaCat, setNovaCat] = useState('');

  async function getCategorias() {
    const { url, options } = GET_CATEGORIAS(tokenGer);
    const response = await fetch(url, options);
    const json = await response.json();
    if (!response.ok) throw new Error('Erro ao trazer categorias');
    setCategorias(json);
  }

  function onChangeNovaCat(e: React.ChangeEvent<HTMLInputElement>) {
    setNovaCat(e.target.value);
  }

  function fecharModal() {
    setEmailSent(false);
    navigate('/area-gerencial/videos');
  }

  function fecharModalCat() {
    setOpenAddCat(false);
  }

  async function fecharModalAddCat() {
    try {
      const { url, options } = NOVA_CATEGORIA(tokenGer, { descricao: novaCat });
      const response = await fetch(url, options);
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
    } catch (error) {
      console.log(error);
    } finally {
      setOpenAddCat(false);
      getCategorias();
    }
  }

  async function enviaVideo() {
    try {
      setLoading(true);
      const { url, options } = EDIT_VIDEO(tokenGer, formData);
      const response = await fetch(url, options);
      const { message } = await response.json();

      if (!response.ok) throw new Error(message);
      setMensagem(message);
      setEmailSent(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setInitialValues({
      id: video?.id,
      url: video?.url,
      titulo: video?.titulo,
      descricao: video?.descricao,
      categoria_id: video?.categoria_id,
      convenio_id: video?.convenio_id === null ? '' : video?.convenio_id,
    });
  }, [video]);

  return (
    <section className={`${styles.containerMain} animeLeft`}>
      <Modal
        className={styles.modal}
        isOpen={emailSent}
        onRequestClose={fecharModal}
        ariaHideApp={false}
      >
        <p>{mensagem}</p>
        <Button descricao="fechar" classe="second" onClick={fecharModal} />
      </Modal>
      <Modal
        className={styles.modal}
        isOpen={openAddCat}
        onRequestClose={fecharModalCat}
        ariaHideApp={false}
      >
        <h2>Nova Categoria</h2>
        <Input
          label="Categoria"
          type="text"
          name="categoria"
          value={novaCat}
          onChange={onChangeNovaCat}
        />
        <Button
          descricao="salvar"
          classe="submit"
          onClick={fecharModalAddCat}
        />
      </Modal>
      <div className={styles.divTitulo}>
        <TituloAssociado titulo={'Editar Video'} />
        <Button
          descricao="+ nova categoria"
          classe="third"
          onClick={() => {
            setNovaCat('');
            setOpenAddCat(true);
          }}
        />
      </div>
      <div className={styles.divForm}>
        <VideoForm initialValues={initialValues} />
        <div className={styles.botoes}>
          <Button descricao="salvar" classe="submit" onClick={enviaVideo} />
        </div>
      </div>
    </section>
  );
};

export default EditarVideo;
